import { render, staticRenderFns } from "./telPerNew.vue?vue&type=template&id=72998b1a&scoped=true&"
import script from "./telPerNew.vue?vue&type=script&lang=js&"
export * from "./telPerNew.vue?vue&type=script&lang=js&"
import style0 from "./telPerNew.vue?vue&type=style&index=0&id=72998b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72998b1a",
  null
  
)

export default component.exports